import React from "react";
import { Field } from "redux-form/immutable";
import { Grid } from "@material-ui/core";

import { CREW_FORM } from "features/planner/planner.constants";
import TextField from "app/components/form/TextField";

const renderTextField = props => (
  <Field fullWidth margin="normal" component={TextField} {...props} />
);

const CrewForm = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} id={CREW_FORM.ID}>
      <Grid container>
        <Grid item xs={12}>
          {renderTextField({
            label: "Name",
            required: true,
            autoFocus: true,
            name: CREW_FORM.NAME,
          })}
        </Grid>
      </Grid>
    </form>
  );
};

export default React.memo(CrewForm);
